(function () {
  function initHowToStepsSection(section) {
    if (!section) return;

    var track = section.querySelector('[data-how-to-track]');
    if (!track) return;

    // Keep videos muted/autoplay-safe for mobile browsers and theme editor previews.
    var videos = section.querySelectorAll('.htm__media video');
    videos.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          // Ignore autoplay blocking errors; user interaction can start playback.
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.htm[data-section-id]').forEach(initHowToStepsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var loadedSection = document.querySelector('.htm[data-section-id="' + event.detail.sectionId + '"]');
    initHowToStepsSection(loadedSection);
  });
})();
